import { createAction } from '@reduxjs/toolkit';
import { errorPayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { TaxInput, TaxInputProps, TaxProps } from './taxesTypes';

const syncTaxPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<TaxProps>>();
const syncTaxInputPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<TaxInputProps>>();
const taxInputPayloadCreator = getPayloadCreator<TaxInput>();

export const createTaxInput = createAction('CREATE_TAX_INPUT', taxInputPayloadCreator);
export const createTaxInputSuccess = createAction('CREATE_TAX_INPUT_SUCCESS', taxInputPayloadCreator);
export const createTaxInputFailure = createAction('CREATE_TAX_INPUT_FAILURE', errorPayloadCreator);

export const updateTaxInput = createAction('UPDATE_TAX_INPUT', taxInputPayloadCreator);
export const updateTaxInputSuccess = createAction('UPDATE_TAX_INPUT_SUCCESS', taxInputPayloadCreator);
export const updateTaxInputFailure = createAction('UPDATE_TAX_INPUT_FAILURE', errorPayloadCreator);

export const deleteTaxInput = createAction('DELETE_TAX_INPUT', taxInputPayloadCreator);
export const deleteTaxInputSuccess = createAction('DELETE_TAX_INPUT_SUCCESS', taxInputPayloadCreator);
export const deleteTaxInputFailure = createAction('DELETE_TAX_INPUT_FAILURE', errorPayloadCreator);

export const getTaxInputs = createAction('GET_TAX_INPUTS', getPayloadCreator());
export const getTaxInputsSuccess = createAction('GET_TAX_INPUTS_SUCCESS', syncTaxInputPayloadCreator);
export const getTaxInputsFailure = createAction('GET_TAX_INPUTS_FAILURE', errorPayloadCreator);

export const performTaxCalc = createAction('PERFORM_TAX_CALC', getPayloadCreator<string>());
export const performTaxCalcSuccess = createAction('PERFORM_TAX_CALC_SUCCESS', syncTaxPayloadCreator);
export const performTaxCalcFailure = createAction('PERFORM_TAX_CALC_FAILURE', errorPayloadCreator);

export const getTaxCalculations = createAction('GET_TAX_CALCULATIONS', getPayloadCreator());
export const getTaxCalculationsSuccess = createAction('GET_TAX_CALCULATIONS_SUCCESS', syncTaxPayloadCreator);
export const getTaxCalculationsFailure = createAction('GET_TAX_CALCULATIONS_FAILURE', errorPayloadCreator);

export const getTaxCalculation = createAction('GET_TAX_CALCULATION', getPayloadCreator());
export const getTaxCalculationSuccess = createAction('GET_TAX_CALCULATION_SUCCESS', syncTaxPayloadCreator);
export const getTaxCalculationFailure = createAction('GET_TAX_CALCULATION_FAILURE', errorPayloadCreator);

export const performTaxPlanRefresh = createAction('PERFORM_TAX_REFRESH', getPayloadCreator<TaxInputProps>());
export const performTaxPlanRefreshSuccess = createAction('PERFORM_TAX_REFRESH_SUCCESS', getPayloadCreator());
export const performTaxPlanRefreshFailure = createAction('PERFORM_TAX_REFRESH_FAILURE', errorPayloadCreator);
